// services/charge.service.ts — one-off "collect a payment" charges (Stripe
// PaymentIntents). Pairs with WebAPI PaymentsController /charge + /history.
// Card data is confirmed client-side with Stripe.js and never hits our API.
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ChargeRequest {
  userId: number;
  amount: number;
  description?: string;
  projectId?: string;
  paymentMethodId?: string;
}

export interface ChargeResult {
  paymentId: number;
  paymentIntentId: string;
  clientSecret: string;
  status: string;
}

export interface PaymentHistoryItem {
  id: number;
  userId: number;
  stripePaymentIntentId: string;
  amount: number;
  currency: string;
  status: string;
  description?: string;
  projectId?: number;
  createdAt: string;
}

@Injectable({ providedIn: 'root' })
export class ChargeService {
  private apiUrl = environment.apiUrl + 'Payments/';

  constructor(private http: HttpClient) {}

  charge(req: ChargeRequest): Observable<ChargeResult> {
    return this.http.post<ChargeResult>(`${this.apiUrl}charge`, req);
  }

  getHistory(userId: number): Observable<PaymentHistoryItem[]> {
    return this.http.get<PaymentHistoryItem[]>(`${this.apiUrl}history/${userId}`);
  }
}
